<tvcore-ivv-title title="Ons aanbod"></tvcore-ivv-title>

<div class="grey-container u-m-top--md u-m-bottom--md">
	<p class="u-m-bottom--md">
		<a [routerLink]="['/']">{{ 'FAVORITES.HOME_BUTTON' | translate }}</a>
		<span class="u-text--grey-blue"> &gt;</span>
		{{ 'FAVORITES.TITLE' | translate }}
	</p>

	<p class="u-title u-title--line u-m-bottom--sm">{{ 'FAVORITES.TITLE' | translate }}</p>
	<p class="u-width--md">{{ 'FAVORITES.DESCRIPTION' | translate }}</p>

	@if (favorites$ | async; as favorites) {
		@if (favorites.length) {
			<div class="u-m-top--sm flex-row">
				<button (click)="showShareLink()" class="c-btn c-btn--with-icon">
					<tvcore-icon name="share"></tvcore-icon>
					{{ 'FAVORITES.SHARE_BUTTON' | translate }}
				</button>
			</div>
		}
	}
</div>

@if (favorites$ | async; as favorites) {
	@if (favorites.length) {
		<div class="c-cards-grid">
			@for (offer of favorites; track offer.id) {
				<ivva-offer-card [fromFavorites]="true" [offer]="offer"></ivva-offer-card>
			}
		</div>
	} @else {
		<p [innerHTML]="'FAVORITES.EMPTY' | translate" class="u-width--md"></p>

		<a [routerLink]="['/']" class="c-btn-link c-btn--with-icon back-btn u-m-top--sm u-text--medium">
			<tvcore-icon name="arrow"></tvcore-icon>
			{{ 'FAVORITES.BACK_BUTTON' | translate }}
		</a>
	}
}

<tvcore-dialog (close)="shareLink.set(null)" [title]="'DETAIL.SHARE_DIALOG.TITLE' | translate" [visible]="!!shareLink()">
	<p class="u-m-bottom--xs">{{ 'DETAIL.SHARE_DIALOG.DESCRIPTION' | translate }}</p>
	<p class="u-text--medium u-m-bottom--tiny">{{ 'DETAIL.SHARE_DIALOG.LINK' | translate }}</p>

	<div class="link-box">
		<div id="linkaddress">{{ shareLink() }}</div>
		<button (click)="copyLink()" class="c-btn c-btn--sm c-btn--blue">{{ 'DETAIL.SHARE_DIALOG.COPY_BUTTON' | translate }}</button>
	</div>
</tvcore-dialog>

<ivva-help></ivva-help>
